<script setup lang="ts">
defineOptions({
	name: 'IconBrain',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:class="[props.class, props.classIcon]"
		viewBox="0 0 31 31"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.0663 4.74576C15.6076 5.1169 14.9519 5.1169 14.4932 4.74576C13.4906 3.94567 12.1487 3.71327 10.9355 4.1296C9.72222 4.54593 8.80577 5.55326 8.50568 6.80036C8.39955 7.28558 8.01965 7.66402 7.53402 7.76826C6.10638 8.05802 4.91647 9.03909 4.35987 10.3853C3.80327 11.7315 3.95294 13.2665 4.75912 14.4798C5.04961 14.9051 5.04961 15.4651 4.75912 15.8904C3.95294 17.1037 3.80327 18.6387 4.35987 19.9849C4.91647 21.3311 6.10638 22.3122 7.53402 22.6019C8.01965 22.7062 8.39955 23.0846 8.50568 23.5698C8.80741 24.8159 9.72452 25.8215 10.9375 26.2365C12.1505 26.6515 13.4915 26.4183 14.4932 25.6182C14.9519 25.2471 15.6076 25.2471 16.0663 25.6182C17.0698 26.4183 18.4126 26.6499 19.6261 26.2322C20.8396 25.8145 21.7554 24.8055 22.0538 23.5573C22.1599 23.0721 22.5398 22.6937 23.0255 22.5894C24.4533 22.2995 25.6433 21.3181 26.1996 19.9715C26.756 18.625 26.6059 17.0899 25.7991 15.8766C25.5098 15.4519 25.5098 14.8933 25.7991 14.4686C26.6059 13.2553 26.756 11.7202 26.1996 10.3736C25.6433 9.0271 24.4533 8.04568 23.0255 7.75576C22.5398 7.65151 22.1599 7.27308 22.0538 6.78786C21.7521 5.54184 20.835 4.53618 19.622 4.1212C18.409 3.70623 17.068 3.9394 16.0663 4.7395V4.74576Z"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M15.2797 5.02197V25.3342"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.0314 20.181C19.0314 18.7997 20.1511 17.6799 21.5324 17.6799"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.5282 10.1768C11.5282 11.558 10.4084 12.6778 9.02716 12.6778"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.5282 20.181C11.5282 18.7997 10.4084 17.6799 9.02716 17.6799"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.0314 10.1768C19.0314 11.558 20.1511 12.6778 21.5324 12.6778"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
